module.exports = "static/assets/9d5be1463602fd5ac397d01e8a436eb2.png";